import * as e from "react";
import { c as t } from "../createReactComponent-58f9bea8.mjs";
import { c as o, r } from "../segmentedcontrol-a5e8d97c.mjs";
import { S as C, b as d, a as f } from "../segmentedcontrol-a5e8d97c.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const c = t({ tagName: "ex-segmentedcontrol", elementClass: o, react: e, events: { onChange: "onSelection" }, displayName: "ExSegmentedControl", registerWebComponent: r });
export {
  c as ExSegmentedControl,
  C as SegmentPlace,
  d as SegmentTooltipPosition,
  f as SegmentVariant,
  r as register
};
